const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const Cast = require('../../util/cast');
const formatMessage = require('format-message');
const MathUtil = require('../../util/math-util');
const Timer = require('../../util/timer');

/**
 * Icon svg to be displayed at the left edge of each extension block, encoded as a data URI.
 * @type {string}
 */
// eslint-disable-next-line max-len
const blockIconURI = 'data:image/svg+xml;base64,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';


/**
 * Host for the Pen-related blocks in Scratch 3.0
 * @param {Runtime} runtime - the runtime instantiating this block package.
 * @constructor
 */
class Scratch3GakkoBlocks {
    constructor (runtime) {
        /**
         * The runtime instantiating this block package.
         * @type {Runtime}
         */
        this.runtime = runtime;
    }

    /**
     * @returns {object} metadata for this extension and its blocks.
     */
    getInfo () {
        return {
            id: 'gakko',
            name: formatMessage({
                id: 'gakko.categoryName',
                default: 'gakko',
                description: 'Label for the gakko extension category'
            }),
            blockIconURI: blockIconURI,
            blocks: [
                {
                    opcode: 'jump',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'gakko.jump',
                        default: 'jump [STEPS]',
                        description: 'Sprite will jump'
                    }),
                    arguments: {
                        STEPS: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 10
                        }
                    }
                }
            ]
        };
    }

    getMonitored () {
        return {
            motion_xposition: {
                isSpriteSpecific: true,
                getId: targetId => `${targetId}_xposition`
            },
            motion_yposition: {
                isSpriteSpecific: true,
                getId: targetId => `${targetId}_yposition`
            },
            motion_direction: {
                isSpriteSpecific: true,
                getId: targetId => `${targetId}_direction`
            }
        };
    }

    jump (args, util) {
        const times = Math.floor(Cast.toNumber(args.STEPS));

        if (typeof util.stackFrame.loopCounter === 'undefined') {
            util.stackFrame.endX = util.target.x;
            util.stackFrame.endY = util.target.y;
            util.stackFrame.loopCounter = times;
            util.stackFrame.isJump = true;
            util.stackFrame.isRotate = false;
            util.stackFrame.isReturn = false;
        }

        util.stackFrame.startX = util.target.x;
        util.stackFrame.startY = util.target.y;

        if (util.stackFrame.isJump && util.stackFrame.loopCounter > 0) {
            util.target.setXY(
                util.stackFrame.startX,
                util.stackFrame.startY + 3
            );
            util.stackFrame.loopCounter--;
            util.yield();
        } else if (util.stackFrame.isJump && util.stackFrame.loopCounter <= 0) {
            util.stackFrame.isRotate = true;
            util.stackFrame.isJump = false;
            util.stackFrame.loopCounter = 20;
            util.yield();
        } else if (util.stackFrame.isRotate && util.stackFrame.loopCounter > 0) {
            util.target.setDirection(util.target.direction + 18);
            util.stackFrame.loopCounter--;
            util.yield();
        } else if (util.stackFrame.isRotate && util.stackFrame.loopCounter <= 0) {
            util.stackFrame.isReturn = true;
            util.stackFrame.isRotate = false;
            util.stackFrame.loopCounter = times;
            util.yield();
        } else if (util.stackFrame.isReturn && util.stackFrame.loopCounter > 0) {
            util.target.setXY(
                util.stackFrame.startX,
                util.stackFrame.startY - 3
            );
            util.stackFrame.loopCounter--;
            util.yield();
        } else {
            util.target.setXY(util.stackFrame.endX, util.stackFrame.endY);
        }
    }

    goToXY (args, util) {
        const x = Cast.toNumber(args.X);
        const y = Cast.toNumber(args.Y);
        util.target.setXY(x, y);
    }

    getTargetXY (targetName, util) {
        let targetX = 0;
        let targetY = 0;
        if (targetName === '_mouse_') {
            targetX = util.ioQuery('mouse', 'getScratchX');
            targetY = util.ioQuery('mouse', 'getScratchY');
        } else if (targetName === '_random_') {
            const stageWidth = this.runtime.constructor.STAGE_WIDTH;
            const stageHeight = this.runtime.constructor.STAGE_HEIGHT;
            targetX = Math.round(stageWidth * (Math.random() - 0.5));
            targetY = Math.round(stageHeight * (Math.random() - 0.5));
        } else {
            const goToTarget = this.runtime.getSpriteTargetByName(targetName);
            if (!goToTarget) return;
            targetX = goToTarget.x;
            targetY = goToTarget.y;
        }
        return [targetX, targetY];
    }

    goTo (args, util) {
        const targetXY = this.getTargetXY(args.TO, util);
        if (targetXY) {
            util.target.setXY(targetXY[0], targetXY[1]);
        }
    }

    turnRight (args, util) {
        const degrees = Cast.toNumber(args.DEGREES);
        util.target.setDirection(util.target.direction + degrees);
    }

    turnLeft (args, util) {
        const degrees = Cast.toNumber(args.DEGREES);
        util.target.setDirection(util.target.direction - degrees);
    }

    pointInDirection (args, util) {
        const direction = Cast.toNumber(args.DIRECTION);
        util.target.setDirection(direction);
    }

    pointTowards (args, util) {
        let targetX = 0;
        let targetY = 0;
        if (args.TOWARDS === '_mouse_') {
            targetX = util.ioQuery('mouse', 'getScratchX');
            targetY = util.ioQuery('mouse', 'getScratchY');
        } else {
            const pointTarget = this.runtime.getSpriteTargetByName(args.TOWARDS);
            if (!pointTarget) return;
            targetX = pointTarget.x;
            targetY = pointTarget.y;
        }

        const dx = targetX - util.target.x;
        const dy = targetY - util.target.y;
        const direction = 90 - MathUtil.radToDeg(Math.atan2(dy, dx));
        util.target.setDirection(direction);
    }

    glide (args, util) {
        if (util.stackFrame.timer) {
            const timeElapsed = util.stackFrame.timer.timeElapsed();
            if (timeElapsed < util.stackFrame.duration * 1000) {
                // In progress: move to intermediate position.
                const frac = timeElapsed / (util.stackFrame.duration * 1000);
                const dx = frac * (util.stackFrame.endX - util.stackFrame.startX);
                const dy = frac * (util.stackFrame.endY - util.stackFrame.startY);
                util.target.setXY(
                    util.stackFrame.startX + dx,
                    util.stackFrame.startY + dy
                );
                util.yield();
            } else {
                // Finished: move to final position.
                util.target.setXY(util.stackFrame.endX, util.stackFrame.endY);
            }
        } else {
            // First time: save data for future use.
            util.stackFrame.timer = new Timer();
            util.stackFrame.timer.start();
            util.stackFrame.duration = Cast.toNumber(args.SECS);
            util.stackFrame.startX = util.target.x;
            util.stackFrame.startY = util.target.y;
            util.stackFrame.endX = Cast.toNumber(args.X);
            util.stackFrame.endY = Cast.toNumber(args.Y);
            if (util.stackFrame.duration <= 0) {
                // Duration too short to glide.
                util.target.setXY(util.stackFrame.endX, util.stackFrame.endY);
                return;
            }
            util.yield();
        }
    }

    glideTo (args, util) {
        const targetXY = this.getTargetXY(args.TO, util);
        if (targetXY) {
            this.glide({ SECS: args.SECS, X: targetXY[0], Y: targetXY[1] }, util);
        }
    }

    ifOnEdgeBounce (args, util) {
        const bounds = util.target.getBounds();
        if (!bounds) {
            return;
        }
        // Measure distance to edges.
        // Values are positive when the sprite is far away,
        // and clamped to zero when the sprite is beyond.
        const stageWidth = this.runtime.constructor.STAGE_WIDTH;
        const stageHeight = this.runtime.constructor.STAGE_HEIGHT;
        const distLeft = Math.max(0, (stageWidth / 2) + bounds.left);
        const distTop = Math.max(0, (stageHeight / 2) - bounds.top);
        const distRight = Math.max(0, (stageWidth / 2) - bounds.right);
        const distBottom = Math.max(0, (stageHeight / 2) + bounds.bottom);
        // Find the nearest edge.
        let nearestEdge = '';
        let minDist = Infinity;
        if (distLeft < minDist) {
            minDist = distLeft;
            nearestEdge = 'left';
        }
        if (distTop < minDist) {
            minDist = distTop;
            nearestEdge = 'top';
        }
        if (distRight < minDist) {
            minDist = distRight;
            nearestEdge = 'right';
        }
        if (distBottom < minDist) {
            minDist = distBottom;
            nearestEdge = 'bottom';
        }
        if (minDist > 0) {
            return; // Not touching any edge.
        }
        // Point away from the nearest edge.
        const radians = MathUtil.degToRad(90 - util.target.direction);
        let dx = Math.cos(radians);
        let dy = -Math.sin(radians);
        if (nearestEdge === 'left') {
            dx = Math.max(0.2, Math.abs(dx));
        } else if (nearestEdge === 'top') {
            dy = Math.max(0.2, Math.abs(dy));
        } else if (nearestEdge === 'right') {
            dx = 0 - Math.max(0.2, Math.abs(dx));
        } else if (nearestEdge === 'bottom') {
            dy = 0 - Math.max(0.2, Math.abs(dy));
        }
        const newDirection = MathUtil.radToDeg(Math.atan2(dy, dx)) + 90;
        util.target.setDirection(newDirection);
        // Keep within the stage.
        const fencedPosition = util.target.keepInFence(util.target.x, util.target.y);
        util.target.setXY(fencedPosition[0], fencedPosition[1]);
    }

    setRotationStyle (args, util) {
        util.target.setRotationStyle(args.STYLE);
    }

    changeX (args, util) {
        const dx = Cast.toNumber(args.DX);
        util.target.setXY(util.target.x + dx, util.target.y);
    }

    setX (args, util) {
        const x = Cast.toNumber(args.X);
        util.target.setXY(x, util.target.y);
    }

    changeY (args, util) {
        const dy = Cast.toNumber(args.DY);
        util.target.setXY(util.target.x, util.target.y + dy);
    }

    setY (args, util) {
        const y = Cast.toNumber(args.Y);
        util.target.setXY(util.target.x, y);
    }

    getX (args, util) {
        return util.target.x;
    }

    getY (args, util) {
        return util.target.y;
    }

    getDirection (args, util) {
        return util.target.direction;
    }


}

module.exports = Scratch3GakkoBlocks;
